import { useQuery } from '@tanstack/react-query';
import { getRecipes } from '../api';
import type { RecipeFilters } from '../types';

export const RECIPES_QUERY_KEY = 'recipes';

interface UseRecipesOptions {
  filters?: RecipeFilters;
  enabled?: boolean;
}

/**
 * Hook for fetching recipes with TanStack Query.
 */
export function useRecipes({
  filters,
  enabled = true,
}: UseRecipesOptions = {}) {
  return useQuery({
    queryKey: [RECIPES_QUERY_KEY, filters],
    queryFn: () => getRecipes(filters),
    enabled,
    staleTime: 60_000,
    gcTime: 5 * 60 * 1000,
  });
}
